import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, PlusSquare, Search, Sparkles, User } from 'lucide-react';

import { cn } from '@/lib/utils';
import { useI18n } from '@/hooks/use-i18n';

const items = [
  { key: 'home', href: '/', icon: Home, labelKey: 'nav.home' },
  { key: 'browse', href: '/browse', icon: Search, labelKey: 'nav.explore' },
  { key: 'submit', href: '/submit', icon: PlusSquare, labelKey: 'nav.submit' },
  { key: 'profile', href: '/profile', icon: User, labelKey: 'nav.profile' },
];

export function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <>
      <button
        type="button"
        onClick={() => navigate('/submit')}
        className="fixed bottom-[5.75rem] right-3 z-40 inline-flex h-12 max-w-[calc(50vw-1rem)] items-center justify-center gap-1.5 rounded-full border border-cyan-100 bg-gradient-to-r from-[#14B8A6] to-[#22D3EE] px-3.5 text-[13px] font-semibold text-white shadow-[0_18px_36px_rgba(34,211,238,0.22)] transition-transform duration-200 active:scale-[0.97] md:hidden"
      >
        <Sparkles className="h-4 w-4 shrink-0" />
        <span className="truncate">{t('nav.mobilePost')}</span>
      </button>

      <div className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/94 px-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] pt-2 shadow-[0_-2px_12px_rgba(0,0,0,0.06)] backdrop-blur-2xl md:hidden">
        <div className="mx-auto flex h-[68px] w-full max-w-md items-center gap-1 overflow-hidden rounded-[28px] border border-slate-200 bg-white px-1.5 py-2 shadow-[0_18px_50px_-22px_rgba(148,163,184,0.38)]">
          {items.map((item) => {
            const active = item.href === '/' ? location.pathname === '/' : location.pathname.startsWith(item.href);
            const Icon = item.icon;

            return (
              <button
                key={item.key}
                type="button"
                onClick={() => navigate(item.href)}
                className={cn(
                  'flex h-full min-w-0 flex-1 flex-col items-center justify-center gap-1 rounded-2xl px-2 py-2 text-[10px] font-medium transition-all sm:text-[11px]',
                  active
                    ? 'bg-cyan-50 text-[#14B8A6] shadow-[0_12px_28px_rgba(34,211,238,0.12)]'
                    : 'text-slate-500 hover:bg-slate-50 hover:text-slate-900'
                )}
              >
                <Icon className="h-4 w-4" />
                <span className="max-w-full truncate">{t(item.labelKey)}</span>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}
